import { RequestSender } from "./helpers";

export type WebProgressRecord = {
  studentId?: string;
  progress: Record<string, any>;
  lastUpdated?: string;
};

// What Unity / frontend SENDS
export type WebProgressPayload = {
  progress: Record<string, any>;
};

export type PracticeLevelProgress = {
  levelIndex: number;
  numCorrect: number;
  isMastered: boolean;
};

export type PracticeProgress = {
  remediationRequired: boolean;
  remediationDeferred: boolean;
  level0NumCorrect: number;
  level0Completed: boolean;
  levels: PracticeLevelProgress[];
};

/* -------------------------------
   GET: Fetch student web progress
-------------------------------- */
/*export async function getWebProgress(
  request: RequestSender,
  //studentId: string
): Promise<WebProgressRecord> {
  const response = await request(
    "get",
    `/web-progress`
  );
  if (response.status !== 200 || !response.data) {
    throw new Error(response.data?.message ?? "Failed to fetch web progress");
  }
  console.log(response.data);
  return response.data as unknown as WebProgressRecord;
}
*/
export async function getWebProgress(
  request: RequestSender,
): Promise<{ progress: Record<string, any> }> {
  const response = await request<any>("get", "/web-progress");

  // 🔑 Backend may return:
  // 1) { progress: {...} }
  // 2) {}
  // 3) null
  // 4) { data: {...} } (rare but possible)

  const raw = response.data as any;

  if (raw?.data?.progress) {
    return raw.data;
  }

  if (raw?.progress) {
    return { progress: raw.progress };
  }

  // Empty / first-time user case
  return { progress: {} };
}

/* -------------------------------
   POST: Save or overwrite progress
-------------------------------- */
export async function saveWebProgress(
  request: RequestSender,
  progress: Record<string, any>,
): Promise<void> {
  const response = await request("post", `/web-progress`, { progress });
  if (response.status !== 200) {
    throw new Error("Failed to save web progress");
  }
}

/* -------------------------------
   PATCH: Partial updates
-------------------------------- */
export async function patchWebProgress(
  request: RequestSender,
  //studentId: string,
  updates: Array<{ path: string; value: any }>,
): Promise<void> {
  const response = await request("patch", `/web-progress`, { updates });
  if (response.status !== 200) {
    throw new Error("Failed to patch web progress");
  }
}

export async function getPracticeProgress(
  request: RequestSender,
  activityId: string,
): Promise<PracticeProgress | null> {
  const response = await request<{ progress: PracticeProgress | null }>(
    "get",
    `/web-progress/practice/${encodeURIComponent(activityId)}`,
  );
  return response.data.data?.progress ?? null;
}

export async function savePracticeProgress(
  request: RequestSender,
  activityId: string,
  progress: PracticeProgress,
): Promise<void> {
  await request(
    "put",
    `/web-progress/practice/${encodeURIComponent(activityId)}`,
    progress,
  );
}
